import { News } from 'types';

export const news: News = {
  id: '',
  offline: false,
  immediate: false,

  title: '',
  img: '',
  text: '',

  // defined in @checkConditions NewsManager
  conditions: [],
  action: null,

  timestamp: Date.now(),
};
